import React, { Component } from 'react';
import classNames from 'classnames';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = ".rAvgR{height:.1px;opacity:0;overflow:hidden;position:absolute;width:.1px;z-index:-1}";
var styles = {"visuallyHidden":"rAvgR"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class FileInput extends Component {
  constructor(props) {
    super(props);
    this.value = null;
    this.onClick = () => {
      const { handleFileSelection, multiple } = this.props;
      handleFileSelection == null ? void 0 : handleFileSelection(multiple);
    };
    this.handleChange = (e) => {
      this.props.onChange(Array.from(e.target.files || []));
      e.target.value = null;
    };
    this.onKeyPress = (e) => {
      var _a, _b;
      return e.key === "Enter" && ((_b = (_a = this.inputRef) == null ? void 0 : _a.current) == null ? void 0 : _b.click());
    };
    this.styles = mergeStyles({ styles, theme: props.theme });
    this.state = { focused: false };
    this.id = `file_input_${Math.floor(Math.random() * 9999)}`;
    this.inputRef = props == null ? void 0 : props.inputRef;
  }
  onFocus() {
    this.setState({ focused: true });
  }
  onBlur() {
    this.setState({ focused: false });
  }
  render() {
    const {
      accept,
      multiple,
      className,
      title,
      children,
      dataHook,
      tabIndex,
      disabled,
      handleFileSelection
    } = this.props;
    const hasMultiple = multiple ? { multiple } : {};
    const { styles: styles2 } = this;
    const a11yProps = {
      role: "button",
      "aria-label": title
    };
    return (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      /* @__PURE__ */ React.createElement(
        "label",
        {
          disabled,
          htmlFor: this.id,
          className: classNames(__spreadProps(__spreadValues({}, className ? { [className]: true } : void 0), {
            [styles2.focused]: this.state.focused
          })),
          style: this.props.style,
          title,
          tabIndex,
          "data-hook": "file-input-label",
          onKeyPress: this.onKeyPress,
          onClick: this.onKeyPress
        },
        handleFileSelection ? /* @__PURE__ */ React.createElement(
          "input",
          __spreadProps(__spreadValues({
            disabled,
            className: styles2.visuallyHidden
          }, a11yProps), {
            id: this.id,
            tabIndex: -1,
            "data-hook": dataHook,
            onClick: this.onClick,
            ref: this.inputRef
          })
        ) : /* @__PURE__ */ React.createElement(
          "input",
          __spreadValues(__spreadProps(__spreadValues({}, a11yProps), {
            className: styles2.visuallyHidden,
            disabled,
            id: this.id,
            type: "file",
            "data-hook": dataHook,
            onChange: this.handleChange,
            onClick: () => this.value === null,
            accept,
            onFocus: () => this.onFocus(),
            onBlur: () => this.onBlur(),
            ref: this.inputRef,
            tabIndex: -1
          }), hasMultiple)
        ),
        children
      )
    );
  }
}
FileInput.defaultProps = {
  accept: ".jpg,.png,.gif,.jpeg,.jpe,.jfif,.bmp,.heic,.heif,.tfif,.tif,.webp",
  multiple: false,
  disabled: false
};
var FileInput$1 = React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(FileInput, __spreadValues({ inputRef: ref }, props)));

export { FileInput$1 as default };
//# sourceMappingURL=FileInput.js.map
